import {PublicationListFilterType} from './publication-filter-type';

// Build the query string for a publication list request. Statuses are emitted as
// repeated `status=` params (what the backend ListField expects), not comma-joined.
export function buildPublicationListQuery(page: number | null, filter?: PublicationListFilterType): string {
    const parameters: Array<string> = [];

    if (page) {
        parameters.push(`page=${encodeURIComponent(page)}`);
    }

    if (filter?.createdAtGte) {
        parameters.push(`created_at_gte=${encodeURIComponent(filter.createdAtGte)}`);
    }

    if (filter?.createdAtLte) {
        parameters.push(`created_at_lte=${encodeURIComponent(filter.createdAtLte)}`);
    }

    (filter?.statuses ?? []).forEach((status) => parameters.push(`status=${encodeURIComponent(status)}`));

    return parameters.join('&');
}
